import React from 'react';

const CompositionModal = ({
  showCompositionModal,
  compositionItems,
  handbooks,
  isFieldsLocked,
  calculateDolyaSum,
  isDolyaSumValid,
  isPorodaValid,
  isCompositionValid,
  isCompositionItemValid,
  updateCompositionItem,
  addCompositionItem,
  removeCompositionItem,
  openPicker,
  saveComposition,
  closeCompositionModal
}) => {
  if (!showCompositionModal) return null;

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '20px',
        maxWidth: '600px',
        width: '90%',
        maxHeight: '80vh',
        overflow: 'auto',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          marginBottom: '20px',
          borderBottom: '1px solid #eee',
          paddingBottom: '10px'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
            Редактирование состава насаждения
          </h3>
          <button
            onClick={closeCompositionModal}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
        </div>

        <div style={{ marginBottom: '20px' }}>
          {/* Индикатор валидности состава */}
          <div style={{ 
            marginBottom: '15px', 
            padding: '10px', 
            backgroundColor: isCompositionValid() ? '#d4edda' : '#f8d7da',
            border: `1px solid ${isCompositionValid() ? '#c3e6cb' : '#f5c6cb'}`,
            borderRadius: '4px',
            textAlign: 'center'
          }}>
            <div style={{ 
              color: isCompositionValid() ? '#155724' : '#721c24',
              fontSize: '14px',
              marginBottom: '5px'
            }}>
              <strong>Сумма долей: {calculateDolyaSum()}/10 
              {isDolyaSumValid() ? ' ✓' : ' (должно быть 10)'}</strong>
            </div>
            <div style={{ 
              color: isCompositionValid() ? '#155724' : '#721c24',
              fontSize: '12px'
            }}>
              Породы: {isPorodaValid() ? 'Все выбраны ✓' : 'Не все породы выбраны'}
            </div>
          </div>
          
          <table className="table" style={{ marginBottom: '15px' }}>
            <thead>
              <tr>
                <th style={{ width: '100px' }}>Доля</th>
                <th>Порода</th>
                <th style={{ width: '80px' }}>Действия</th>
              </tr>
            </thead>
            <tbody>
              {compositionItems.map((item) => (
                <tr key={item.id}>
                  <td>
                    <select
                      value={item.dolap}
                      onChange={(e) => {
                        if (!isFieldsLocked) {
                          updateCompositionItem(item.id, 'dolap', e.target.value);
                        }
                      }}
                      disabled={isFieldsLocked}
                      className={`form-control ${isFieldsLocked ? 'locked-field' : ''}`}
                      style={{ 
                        fontSize: '14px',
                        width: '100%',
                        height: '100%',
                        minHeight: '40px',
                        border: 'none',
                        padding: '0',
                        margin: '0',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: isFieldsLocked ? '#f8f9fa' : 'transparent',
                        cursor: isFieldsLocked ? 'not-allowed' : 'pointer'
                      }}
                    >
                      <option value="">Выберите</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="+">+</option>
                    </select>
                  </td>
                  <td>
                    <div 
                      className={`reference-cell ${isFieldsLocked ? 'locked-field' : ''} ${!isCompositionItemValid(item) ? 'is-invalid' : ''}`}
                      onClick={() => {
                        if (!isFieldsLocked) {
                          openPicker('kodporodato', 31, item.id);
                        }
                      }}
                      style={{ 
                        width: '100%',
                        height: '100%',
                        minHeight: '40px',
                        cursor: isFieldsLocked ? 'not-allowed' : 'pointer',
                        background: isFieldsLocked ? '#f8f9fa' : (!isCompositionItemValid(item) ? '#fff5f5' : 'transparent'),
                        border: !isCompositionItemValid(item) ? '2px solid #dc3545' : 'none',
                        padding: '0',
                        margin: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}
                    >
                      <span style={{ 
                        color: item.kodporodato ? '#000' : '#6c757d',
                        fontSize: '14px',
                        flex: 1,
                        padding: '8px'
                      }}>
                        {(() => {
                          const handbook = handbooks.find(h => h.id === 31);
                          if (handbook && handbook.references && item.kodporodato) {
                            const selectedOption = handbook.references.find(r => r.id.toString() === item.kodporodato);
                            return selectedOption ? selectedOption.name : 'Выберите породу';
                          }
                          return 'Выберите породу';
                        })()}
                      </span>
                      <span style={{ color: '#6c757d', fontSize: '12px', paddingRight: '8px' }}>☰</span>
                    </div>
                  </td>
                  <td>
                    <button
                      type="button"
                      onClick={() => removeCompositionItem(item.id)}
                      disabled={compositionItems.length === 1 || isFieldsLocked}
                      style={{
                        background: (compositionItems.length === 1 || isFieldsLocked) ? '#f8f9fa' : '#6c757d',
                        color: (compositionItems.length === 1 || isFieldsLocked) ? '#6c757d' : 'white',
                        border: 'none',
                        padding: '0',
                        margin: '0',
                        width: '100%',
                        height: '100%',
                        minHeight: '40px',
                        cursor: (compositionItems.length === 1 || isFieldsLocked) ? 'not-allowed' : 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Удалить
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          
          {!isFieldsLocked && (
            <button
              type="button"
              onClick={addCompositionItem}
              style={{
                background: '#6c757d',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              + Добавить элемент
            </button>
          )}
        </div>

        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          gap: '10px',
          borderTop: '1px solid #eee',
          paddingTop: '15px'
        }}>
          <button
            type="button"
            onClick={closeCompositionModal}
            style={{
              background: '#6c757d',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Отмена
          </button>
          <button
            type="button"
            onClick={() => {
              if (!isFieldsLocked) {
                saveComposition();
              }
            }}
            disabled={isFieldsLocked || !isCompositionValid()}
            style={{
              background: (isFieldsLocked || !isCompositionValid()) ? '#f8f9fa' : '#6c757d',
              color: (isFieldsLocked || !isCompositionValid()) ? '#6c757d' : 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '4px',
              cursor: (isFieldsLocked || !isCompositionValid()) ? 'not-allowed' : 'pointer',
              fontSize: '14px'
            }}
          >
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompositionModal;

